import { useEffect } from "react";

export const APP_TITLE = "ELGW 5";
export const APP_HOME_TITLE = "ELGW 5 - portal GK ELEKTIM";

// Tytuł ustawiony przez stronę z pobranych danych (nazwa projektu, nr zamówienia...).
// Trzymany modułowo, bo <PageTitle/> z layoutu przebiega przy KAŻDEJ zmianie adresu
// (także przy samym ?tab=), a jego efekt (rodzic) leci PO efekcie strony (dziecko) —
// bez tej wskazówki przełączenie zakładki kasowało nazwę projektu z karty przeglądarki.
let dynamicTitle: string | null = null;

export function getDynamicTitle(): string | null {
  return dynamicTitle;
}

// Sets document.title to `<title> · ELGW 5` while this component is mounted.
// When `title` is null/undefined the call only clears any previous dynamic title
// (lets the route-level PageTitle fallback win).
//
// Use ONLY for pages whose title depends on fetched data (numer zamówienia,
// nazwa klienta itp.). Static titles → handle.title in routes/index.tsx.
export function usePageTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) {
      dynamicTitle = null;
      return;
    }
    dynamicTitle = title;
    document.title = `${title} · ${APP_TITLE}`;
    // Odmontowanie strony (wyjście gdzie indziej) zdejmuje tytuł dynamiczny —
    // cleanup leci przed efektem <PageTitle/>, więc nowa trasa ustawia już swój.
    return () => {
      if (dynamicTitle === title) dynamicTitle = null;
    };
  }, [title]);
}
